import React, { useState, useContext } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
} from "../../../utils";
import { downloadPlanListReport } from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";

function PlanList(props) {
  const formName = manageReportsFormNames.PLAN_LIST_REPORT;
  const fields = formFields[formName];
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });
  const initialValues = { planStatus: "All" };
  const planStatuses = [
    { label: "All", value: null },
    { label: "Active", value: 1, id: 3 },
    { label: "Terminated", value: 2, id: 5 },
    { label: "Under construction", value: 3, id: 0 },
    { label: "Ready for approval", value: 4, id: 1 },
    { label: "Approved", value: 5, id: 2 },
  ];

  const exportReportFile = (payload) => {
    downloadPlanListReport(payload)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `Plan list report_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  const onSubmit = (values) => {
    exportReportFile({
      createdFrom: values[fields.createdFrom],
      createdTo: values[fields.createdTo],
      planStatus: values[fields.planStatus],
    });
  };

  return (
    <ManageReportLayout rptName="Plan List Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const onStatusChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planStatus, fields.planStatusId],
                  }),
                  [fields.planStatusId]:
                    value || value === 0
                      ? parseInt(planStatuses[value].id)
                      : null,
                  [fields.planStatus]:
                    value || value === 0 ? planStatuses[value].label : "All",
                });
              };
              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex mr-2">
                    <Field
                      size="sm"
                      isRequired
                      label={`Plan Status`}
                      name={fields.planStatus}
                      value={values[fields.planStatus]}
                      placeholder="Select One"
                      direction="bottom"
                      // validate={(value) =>
                      //   ["", undefined, null, "Select One"].includes(value) &&
                      //   isEmpty(values[fields.planStatus])
                      //     ? " "
                      //     : null
                      // }
                      popupContent={
                        <SearchableList
                          label="Select Company"
                          options={planStatuses}
                          onSelect={(value) => onStatusChange(value)}
                          selectedValue={values[fields.planStatus]}
                        />
                      }
                      component={FieldDropSide}
                    />
                    <div className="d-flex mr-3 ml-3">
                      <Field
                        size="sm"
                        label="Created from"
                        name={fields.createdFrom}
                        value={usDateFormat(values[fields.createdFrom])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.createdFrom, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.createdFrom, value)
                            }
                            value={usDateFormat(values[fields.createdFrom])}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    {console.log("values", values)}
                    <div className="d-flex mr-3 ml-3">
                      <Field
                        size="sm"
                        label="Created to"
                        name={fields.createdTo}
                        value={usDateFormat(values[fields.createdTo])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.createdTo, null)}
                        validate={(value) => {
                          return value !== null &&
                            value < values[fields.createdFrom] ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Should be ahead of "Created from date"
                            </div>
                          ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                          undefined;
                        }}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.createdTo, value)
                            }
                            value={usDateFormat(values[fields.createdTo])}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    <Button
                      className="mt-12 sort-button "
                      variant="secondary"
                      style={{ marginLeft: "8px", marginTop: "30px" }}
                      type="submit"
                    >
                      Request Report
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
}

export default PlanList;
